import React from "react";
import TextField from "apollo-react/components/TextField";
import Info from 'apollo-react-icons/Info';
const TextInput = ({
	field,
	meta,
	label,
	onChange,
	value,
	required,
	placeholder,
	fullWidth = true,
	multiline = false,
	textareaWidth,
	style
}) => {
	return (
		<TextField
			{...field}
			label={label&&<span style={{display:'flex',alignItems:"flex-start", gap:4, lineHeight:"21px"}}>{label} { <Info fontSize="extraSmall" style={{color:"#595959"}} />}</span>}
			placeholder={placeholder}
			value={value}
			error={meta.touched && meta.error} 
			helperText={meta.touched && meta.error ? meta.error : ""}
			onChange={(e) => onChange(e.target.value)}
			fullWidth={fullWidth}
			multiline={multiline}
			sx={{
				'& textarea': {
				  width: textareaWidth || 240,
				  height: '100px !important',
				},
			  }}
			// required={required}
			style={style}
		/>
	);
};

export default TextInput;
